export default __webpack_public_path__ + "media/images/brands/habitat-999f223876fa699744b06bcc2b24a241.png";